app.ui.registerUi('pop', function (app) {

    var timesRun = 0;
    var timeoutIncrement = 150;

	return {
		implementationExists: function() {
			return true; // implementation is entirely encapsulated within this file.
		},
        onLoaded: function (data) {
            if (data.hasJustLoaded(RESOURCE_NAME__DOM)) {
                this.init();
            }
        },
		init: function ($scope) {
		    var scope = this;

		    // Show pops if the pop area is already visible within the window
            // on page load.
            scope.showPops();

		    // Show pops if they are visible when scrolling.
		    app.globalEventRegistry.addListener('scroll', function () {
			    scope.showPops();
		    });
		},
		deinit: function($scope) {
			app.get.removeListener('pop');
		},
        showPops: function () {
		    var scope = this;
		    var popInterval;
		    scope.debugMessage('Running show pops function. Times run: ' + timesRun);
		    timesRun++;
		    var scrollTopIn = $(document).scrollTop() + 1;
		    var scrollBottomIn = scrollTopIn + $(window).height();
            var $popWrapElems = $('.pop-in').not('.popped-in');
		    if ($popWrapElems.length) {
		        var threshold = 50; // 100px
		        (function (scrollBottom) {
		            var timeStartObj = new Date();
		            var timeStart = timeStartObj.getTime();
		            $popWrapElems.each(function (k, popWrapElem) {
		                var $popWrapElem = $(popWrapElem);
		                var wrapTop = $popWrapElem.offset().top;
		                if (wrapTop < scrollBottom - threshold) {
		                    scope.debugMessage('Starting popping...');
		                    $popWrapElem.addClass('popped-in');
		                    $popWrapElem.trigger('pop.popped');
		                }
		            });
		        })(scrollBottomIn);
		    }
		},
		debugMessage: function (msg) {
		    return;
		    var now = new Date();
		    var t = now.getTime();
		    console.log(t + ': ' + msg);
		}
	};
});
